(function () {
  const STOREFRONT_TOKEN = 'd4d20ada93256beeb50999f3e3e69581';
  const API_URL = 'https://loboo.com/api/2024-01/graphql.json';

  async function gql(query, signal) {
    const res = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({ query }),
      signal
    });
    return res.json();
  }

  async function fetchProducts(keyword, signal) {
    const kw = keyword.trim().replace(/"/g, '');
    const q = `{
      products(first: 8, query: "title:*${kw}*", sortKey: BEST_SELLING) {
        edges {
          node {
            title handle
            images(first: 1) { edges { node { url altText } } }
            priceRange { minVariantPrice { amount currencyCode } }
          }
        }
      }
    }`;
    const data = await gql(q, signal);
    return (data?.data?.products?.edges || []).map(e => e.node);
  }

  function formatPrice(amount, currencyCode) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currencyCode }).format(parseFloat(amount));
    } catch { return `${currencyCode} ${parseFloat(amount).toFixed(2)}`; }
  }

  function renderResults(products, keyword) {
    if (!products.length) {
      return {
        hasResults: false,
        html: `<div class="loboo-search-empty">
          <p>No results for "<strong>${keyword}</strong>"</p>
          <a href="/pages/dealer-portal?q=${encodeURIComponent(keyword)}" class="loboo-search-portal-btn">Search in Product Finder →</a>
        </div>`
      };
    }
    const cards = products.map(p => {
      const imgNode = p.images?.edges?.[0]?.node;
      const imgHtml = imgNode
        ? `<img src="${imgNode.url}&width=80" alt="${imgNode.altText || p.title}" class="loboo-search-card__img" loading="lazy">`
        : `<div class="loboo-search-card__img loboo-search-card__img--placeholder"></div>`;
      const price = formatPrice(p.priceRange.minVariantPrice.amount, p.priceRange.minVariantPrice.currencyCode);
      return `<a href="/products/${p.handle}" class="loboo-search-card">
        ${imgHtml}
        <div class="loboo-search-card__info">
          <span class="loboo-search-card__title">${p.title}</span>
          <span class="loboo-search-card__price">${price}</span>
        </div>
      </a>`;
    }).join('');
    return {
      hasResults: true,
      html: `<div class="predictive-search__results-categories loboo-search-results">
        ${cards}
        <a href="/pages/dealer-portal?q=${encodeURIComponent(keyword)}" class="loboo-search-view-all">View all results in Product Finder →</a>
      </div>`
    };
  }

function hijackDrawer(drawer) {
  if (drawer._lobooHijacked) return;
  drawer._lobooHijacked = true;

  async function searchWithTimeout(term) {
    const controller = new AbortController();
    const parentSignal = this.abortController?.signal;

    let timer;
    let onParentAbort;

    const createAbortError = () =>
      new DOMException('Search cancelled', 'AbortError');

    try {
      if (parentSignal?.aborted) {
        throw createAbortError();
      }

      const timeoutPromise = new Promise((_, reject) => {
        timer = setTimeout(() => {
          const error = new Error('Search timed out');
          error.name = 'SearchTimeoutError';

          reject(error);
          controller.abort();
        }, 10000);
      });

      const cancelPromise = new Promise((_, reject) => {
        onParentAbort = () => {
          reject(createAbortError());
          controller.abort();
        };

        parentSignal?.addEventListener(
          'abort',
          onParentAbort,
          { once: true }
        );
      });

      const products = await Promise.race([
        fetchProducts(term, controller.signal),
        timeoutPromise,
        cancelPromise
      ]);

      // 用户继续输入或清空时，不展示旧请求的结果。
      if (parentSignal?.aborted) {
        throw createAbortError();
      }

      return renderResults(products, term);
    } catch (error) {
      // 保留原主题对主动取消请求的处理。
      if (parentSignal?.aborted) {
        throw createAbortError();
      }

      if (error?.name === 'AbortError') {
        throw error;
      }

      const message = error?.name === 'SearchTimeoutError'
        ? 'Search timed out. Please try again.'
        : 'Search is temporarily unavailable. Please try again.';

      return {
        hasResults: false,
        html: `
          <div class="loboo-search-empty" role="status">
            <p>${message}</p>
            <a
              href="/pages/dealer-portal?q=${encodeURIComponent(term)}"
              class="loboo-search-portal-btn"
            >
              Search in Product Finder →
            </a>
          </div>
        `
      };
    } finally {
      clearTimeout(timer);

      if (onParentAbort) {
        parentSignal?.removeEventListener(
          'abort',
          onParentAbort
        );
      }
    }
  }

  drawer._doPredictiveSearch = searchWithTimeout;
  drawer._doLiquidSearch = searchWithTimeout;
}


  function init() {
    const drawer = document.querySelector('predictive-search-drawer');
    if (drawer) { hijackDrawer(drawer); return; }
    const observer = new MutationObserver(() => {
      const d = document.querySelector('predictive-search-drawer');
      if (d) { observer.disconnect(); hijackDrawer(d); }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  if (window.location.pathname === '/pages/dealer-portal') {
    const autoQ = new URLSearchParams(window.location.search).get('q');
    if (autoQ) {
      window.addEventListener('load', () => {
        const searchInput = document.querySelector('.dealer-portal__search');
        if (searchInput) {
          searchInput.value = autoQ;
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));
          const btn = document.querySelector('.dealer-portal__btn--primary');
          if (btn) btn.click();
        }
      });
    }
  }
})();
